import { useCallback, useState } from "react";
//#region src/presentation/hooks/use-home.ts
var useHome = () => {
	const [count, setCount] = useState(0);
	return {
		count,
		increment: useCallback(() => {
			setCount((current) => current + 1);
		}, []),
		decrement: useCallback(() => {
			setCount((current) => current - 1);
		}, [])
	};
};
//#endregion
export { useHome };

//# sourceMappingURL=use-home.js.map